(() => {
  const openDrawer = (search) => {
    const trigger = document.querySelector('.wt-header__localization__triggers .wt-localization-trigger');
    const drawer = document.querySelector('localization-drawer');
    if (!trigger || !drawer) return;
    trigger.click();
    drawer.setActiveTab('country');
    const input = document.querySelector('.wt-localization-drawer__search-country__input');
    if (!input) return;
    input.value = search;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vc-cq-search]');
    if (!button) return;
    event.preventDefault();
    button.blur();
    openDrawer(button.dataset.vcCqSearch);
  });

  // EUR switches in one tap: use the browser's region when it is a euro country,
  // else the main euro country of the browser's language, else keep the default.
  const langCountry = { de: 'DE', fr: 'FR', it: 'IT', es: 'ES', nl: 'NL', pt: 'PT', fi: 'FI', el: 'GR', et: 'EE', lv: 'LV', lt: 'LT', sk: 'SK', sl: 'SI', hr: 'HR', mt: 'MT', ga: 'IE', lb: 'LU', bg: 'BG' };
  const parts = (navigator.languages || [navigator.language || ''])
    .filter(Boolean)
    .map((lang) => lang.split('-'));
  document.querySelectorAll('[data-vc-cq-eur]').forEach((button) => {
    const codes = button.dataset.vcCqEur.split(',');
    const region = parts.map((p) => (p[1] || '').toUpperCase()).find((r) => codes.includes(r));
    const byLang = parts.map((p) => langCountry[p[0].toLowerCase()]).find((c) => c && codes.includes(c));
    const match = region || byLang;
    if (match) button.value = match;
  });
})();

(() => {
  const root = document.documentElement;
  let queued = false;
  const update = () => {
    queued = false;
    root.classList.toggle('vc-hdr-scrolled', window.scrollY > 10);
  };
  update();
  window.addEventListener('scroll', () => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
})();

// Filter bar: sit below the header only where it can stick to the screen.
// A clipping container around it (search grid, some collection templates) would push it over the photos instead.
(() => {
  const mark = () => {
    document.querySelectorAll('main .collection__sticky-header:not(.vc-bar-under-header)').forEach((bar) => {
      for (let el = bar.parentElement; el && el !== document.body; el = el.parentElement) {
        const style = getComputedStyle(el);
        if (style.overflowX !== 'visible' || style.overflowY !== 'visible') return;
      }
      bar.classList.add('vc-bar-under-header');
    });
  };
  mark();
  // Filters and sorting redraw the grid, which drops the class.
  const main = document.querySelector('main');
  if (main) new MutationObserver(mark).observe(main, { childList: true, subtree: true });
})();
